import { render, staticRenderFns } from "./ContestCard.vue?vue&type=template&id=38cb04e2&scoped=true"
import script from "./ContestCard.vue?vue&type=script&lang=ts"
export * from "./ContestCard.vue?vue&type=script&lang=ts"
import style0 from "./ContestCard.vue?vue&type=style&index=0&id=38cb04e2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cb04e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38cb04e2')) {
      api.createRecord('38cb04e2', component.options)
    } else {
      api.reload('38cb04e2', component.options)
    }
    module.hot.accept("./ContestCard.vue?vue&type=template&id=38cb04e2&scoped=true", function () {
      api.rerender('38cb04e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/ContestCard.vue"
export default component.exports